import { fromFetch } from 'rxjs/fetch';
import UrlExtensions from 'utils/urlExtension';

/**
 * @private
 *
 * The function creates a URL with UTM parameters.
 *
 * @returns a URL with UTM parameters, as well as the values for gclid, httpReferer, and entranceUrl.
 */
function createUtmUrl() {
  const location = window.location;
  const path = '/setUtmParameters';
  const utmSource = UrlExtensions.getParameterValue(location, 'utm_source') ||
  UrlExtensions.getParameterValueFromHash(location, 'utm_source');
  const refer = UrlExtensions.getParameterValue(location, 'refer') ||
  UrlExtensions.getParameterValueFromHash(location, 'refer');
  const utmMedium = UrlExtensions.getParameterValue(location, 'utm_medium') ||
  UrlExtensions.getParameterValueFromHash(location, 'utm_medium');
  const utmCampaign = UrlExtensions.getParameterValue(location, 'utm_campaign') ||
  UrlExtensions.getParameterValueFromHash(location, 'utm_campaign');
  const utmTerm = UrlExtensions.getParameterValue(location, 'utm_term') ||
  UrlExtensions.getParameterValueFromHash(location, 'utm_term');
  const utmContent = UrlExtensions.getParameterValue(location, 'utm_content') ||
  UrlExtensions.getParameterValueFromHash(location, 'utm_content');
  const gclid = UrlExtensions.getParameterValue(location, 'gclid') ||
  UrlExtensions.getParameterValueFromHash(location, 'gclid');
  const httpReferer = document.referrer;
  const entranceUrl = document.location.href;

  const url = UrlExtensions.setParameters(path, {
    refer: UrlExtensions.removeQueryString(refer),
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_term: utmTerm,
    utm_content: utmContent,
    gclid,
    httpReferer,
    entranceUrl,
  });
  return url;
}

export default fromFetch(createUtmUrl(), {
  'credentials': 'include',
  'Accept': 'application/json',
});
